import { extend, get, flatten, uniqBy } from "lodash";

const getters = {
  locations: (state) => state.location.list,
  customers: (state) => state.location.customers,
  userDevices: (state) => state.location.location_users,
  getUsersFromLocation: (state) => {
    return (location_id) => {
      return state.location.location_users.filter((auth) => {
        return auth.location_id === location_id;
      });
    };
  },
  getSmbUsersFromLocation: (state) => {
    return (location_id) => {
      return get(state, "location.location_smb_users", []).filter((user) => {
        return (
          user.role_name !== "shared_user" && user.location_id === location_id
        );
      });
    };
  },
  getDevicesFromLocation: (state) => {
    return (location_id) => {
      let users = state.location.location_users.filter((user) => {
        return user.location_id === location_id;
      });
      return uniqBy(
        flatten(users.map((user) => get(user, "devices", []))),
        "doorbot_id"
      );
    };
  },
  locationDevices: (state, getters) => (location_id) => {
    let data = getters.getDevicesFromLocation(location_id);
    return data.map((dev) => {
      const device = state.location.devices.filter(
        (d) => d.doorbot_id == dev.doorbot_id
      )[0];

      return extend({}, dev, device);
    });
  },
  locationUsers: (state, getters) => (location_id) => {
    if (location_id === undefined) return state.location.customers;
    return getters.getUsersFromLocation(location_id).map((auth) => {
      const user = state.location.customers.filter(
        (c) => c.user_id == auth.user_id
      )[0];

      return extend({}, auth, user);
    });
  },
  locationOwner: (state, getters) => (owner_id) => {
    return state.location.customers.filter((c) => c.user_id == owner_id)[0];
  },
  locationSos: (state, getters) => (location_id) => {
    const locations = state.location.location_sos.filter(
      (location) => location.location_id == location_id
    );
    return locations.length && locations[0];
  },
};

export default getters;
